import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from './styles.module.css';

@autobind
export default class Snackbar extends Component {
    static propTypes = {
        children: PropTypes.any,
        showSnackbar: PropTypes.bool,
        onClick: PropTypes.func,
    };

    render() {
        return (
            <div className={styles.root} id={this.props.showSnackbar ? 'show' : 'hide'} onClick={this.props.onClick}>
                {this.props.children}
            </div>
        );
    }
}
